import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Connects to data-controller="modal"
export default class extends Controller {
  connect() {
  }

  clearTooltips() {
    $('[data-bs-toggle="tooltip"]').each(function(){
      $(this).tooltip('hide')
    })
  }

  /*
   * Opens the shared system_modal Bootstrap modal. Used by many buttons across the app
   * that load content into the single reusable modal element (#system_modal in the layout).
   *
   * The data-focus="no" option allows the trigger button to suppress focus-stealing behavior
   * — useful for buttons that open informational modals where re-focusing the button on close
   * would be disorienting. The default is focus=true (standard modal behavior).
   *
   * When a button has both a tooltip AND opens a modal, Bootstrap tooltips sometimes get
   * stuck visible after the modal opens. We work around this by blurring the button and
   * using setTimeout to forcibly remove any lingering tooltip elements after a brief delay
   * (100ms gives the tooltip hide animation time to start before we nuke the DOM element).
   * clearTooltips() at the end hides any other tooltips that may still be visible.
   */
  loadModal(event) {
    let focus_modal = true;
    // Change for data-focus="no"
    if (event.currentTarget.dataset && event.currentTarget.dataset.focus && (event.currentTarget.dataset.focus == "no")) {
      focus_modal = false;
    }

    if (event.currentTarget.dataset && event.currentTarget.dataset.bsToggle && event.currentTarget.dataset.bsToggle == 'tooltip') {
      // Tooltips on buttons that open modals do not always cleanly close -- remove with force :)
      $(event.currentTarget).blur();
      setTimeout(function(){
        $(".tooltip[role='tooltip']").remove();
      },100);
      // $(event.currentTarget).tooltip('dispose');
    }

    this.modal = new Modal(document.getElementById('system_modal'), {
      keyboard: false,
      focus: focus_modal
    });

    // let modal_container = document.querySelector('#system_modal');
    // this.removeBootstrapModalSizes(modal_container);
    // if (event.currentTarget.dataset && event.currentTarget.dataset.modalSize) {
    //   if (modal_container) {
    //     let dialog_container = modal_container.querySelector('.modal-dialog');
    //     if (dialog_container) {
    //       dialog_container.className = "modal-dialog " + event.currentTarget.dataset.modalSize;
    //     }
    //   }
    // } else {
    //   this.setDefaultBootstrapModalSize(modal_container);
    // }

    this.modal.show();
    this.clearTooltips();
  }
}
